(function () {
  // ----------------------------------------------------------------
  // Per-product CSV override for the allergens table. Reads the raw
  // CSV from <script[data-allergens-csv]>, picks the rows named in
  // `data-allergens-keys` on the section root, then rebuilds the
  // <thead>/<tbody> markup using the same tick/dash spans as the
  // server-rendered fallback. If anything fails it leaves the static
  // table alone.
  // ----------------------------------------------------------------
  function parseCsv(text) {
    if (!text) return [];
    var rows = [], cur = '', row = [], inQuotes = false;
    for (var i = 0; i < text.length; i++) {
      var ch = text[i], next = text[i + 1];
      if (ch === '"') {
        if (inQuotes && next === '"') { cur += '"'; i++; }
        else { inQuotes = !inQuotes; }
      } else if (ch === ',' && !inQuotes) {
        row.push(cur); cur = '';
      } else if ((ch === '\n' || ch === '\r') && !inQuotes) {
        if (ch === '\r' && next === '\n') i++;
        row.push(cur); rows.push(row); row = []; cur = '';
      } else {
        cur += ch;
      }
    }
    if (cur !== '' || row.length > 0) { row.push(cur); rows.push(row); }
    return rows.map(function (r) { return r.map(function (f) { return (f || '').trim(); }); });
  }

  function norm(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  // Find the CSV row whose product name (column 1) best matches `key`.
  // Exact -> substring (either direction) -> >=2-token overlap.
  function findRow(rows, key) {
    var target = norm(key);
    if (!target) return null;
    for (var i = 0; i < rows.length; i++) {
      if (norm(rows[i][1]) === target) return rows[i];
    }
    for (var j = 0; j < rows.length; j++) {
      var rn = norm(rows[j][1]);
      if (rn && (target.indexOf(rn) !== -1 || rn.indexOf(target) !== -1)) return rows[j];
    }
    var targetTokens = {};
    target.split(' ').forEach(function (w) { if (w.length > 2) targetTokens[w] = true; });
    var best = null, bestScore = 0;
    for (var k = 0; k < rows.length; k++) {
      var tokens = norm(rows[k][1]).split(' ').filter(function (w) { return w.length > 2; });
      var score = 0;
      tokens.forEach(function (w) { if (targetTokens[w]) score++; });
      if (score > bestScore) { bestScore = score; best = rows[k]; }
    }
    return bestScore >= 2 ? best : null;
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cellHasYes(raw) { return /\bYES\b/i.test(raw || ''); }
  function cellHasMc(raw) { return /\bMC\b/i.test(raw || ''); }

  // Pretty header label — "GLUTEN" -> "Gluten", "SULPHUR DIOXIDE " ->
  // "Sulphur dioxide". Source CSV is all-caps; this keeps the rendered
  // header readable without relying on CSS text-transform.
  function prettyHeader(name) {
    var n = (name || '').trim();
    if (!n) return '';
    return n.charAt(0).toUpperCase() + n.slice(1).toLowerCase();
  }

  function init() {
    var sections = document.querySelectorAll('[data-allergens-csv-mode]');
    sections.forEach(function (section) {
      var csvEl = section.querySelector('[data-allergens-csv]');
      var table = section.querySelector('.allergens-table');
      if (!csvEl || !table) return;

      var keysRaw = section.getAttribute('data-allergens-keys') || '';
      var keys = keysRaw.split(/[|,]/).map(function (s) { return s.trim(); }).filter(Boolean);
      if (!keys.length) return;

      var rows = parseCsv(csvEl.textContent || '');
      if (rows.length < 2) return;
      var header = rows[0];
      var dataRows = rows.slice(1);

      var matched = [];
      var seen = {};
      keys.forEach(function (k) {
        var r = findRow(dataRows, k);
        if (r && !seen[r[1]]) { matched.push(r); seen[r[1]] = true; }
      });
      if (!matched.length) return;

      var rowHeadLabel = (table.querySelector('.allergens-table__th--row-head') || {}).textContent;
      rowHeadLabel = (rowHeadLabel || 'Item').trim();

      var theadHtml = '<tr>' +
        '<th scope="col" class="allergens-table__th allergens-table__th--row-head">' + esc(rowHeadLabel) + '</th>';
      for (var c = 2; c < header.length; c++) {
        var label = prettyHeader(header[c]);
        if (!label) continue;
        theadHtml += '<th scope="col" class="allergens-table__th">' + esc(label) + '</th>';
      }
      theadHtml += '</tr>';

      var tickSvg = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="M5 12.5l4.5 4.5L20 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      var tbodyHtml = matched.map(function (row) {
        var name = row[1] || '';
        var cells = '';
        for (var c = 2; c < header.length; c++) {
          var colLabel = prettyHeader(header[c]);
          if (!colLabel) continue;
          var raw = row[c] || '';
          var classes = ['allergens-table__cell'];
          var inner;
          if (cellHasYes(raw)) {
            inner = '<span class="allergens-table__tick" aria-label="Contains ' + esc(colLabel) + '">' + tickSvg + '</span>';
          } else if (cellHasMc(raw)) {
            inner = '<span class="allergens-table__dash allergens-table__dash--mc" title="May contain ' + esc(colLabel) + ' (cross-contamination)" aria-label="May contain ' + esc(colLabel) + ' due to cross-contamination"></span>';
            classes.push('allergens-table__cell--mc');
          } else {
            inner = '<span class="allergens-table__dash" aria-label="Does not contain ' + esc(colLabel) + '"></span>';
          }
          cells += '<td class="' + classes.join(' ') + '">' + inner + '</td>';
        }
        return '<tr>' +
          '<th scope="row" class="allergens-table__row-head">' + esc(name) + '</th>' +
          cells +
        '</tr>';
      }).join('');

      var thead = table.querySelector('thead');
      var tbody = table.querySelector('tbody');
      if (thead) thead.innerHTML = theadHtml;
      if (tbody) tbody.innerHTML = tbodyHtml;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
